<div class="form-group mt-auto" [ngClass]="{ 'invalid-control': invalid }">
  <div class="custom-control custom-checkbox pb-2">
    <input
      [disabled]="isDisabled"
      type="checkbox"
      [value]="value"
      (change)="onCheckChange($event)"
      (blur)="onBlur()"
      name="{{ groupName }}"
      [checked]="value"
      id="{{ groupName }}"
      class="custom-control-input"
    />

    <label class="custom-control-label" for="{{ groupName }}">{{ label }}</label>
  </div>

  <partnerhub-error-validation *ngIf="invalid" [errors]="errors"> </partnerhub-error-validation>
</div>
